import { ReactComponent as Tick } from 'Components/UI_Library/Icons/Tick.svg';
import classes from './standardCheckbox.module.css';

type Props = {
    checked?: boolean;
    disabled?: boolean;
};

export const StandardCheckbox = (props: Props) => (
    <div
        className={`${classes.checkbox} ${props.checked ? classes.checked : ''} ${
            props.disabled ? classes.disabled : ''
        }`}
    >
        {props.checked ? <Tick /> : null}
    </div>
);

export default StandardCheckbox;
